module.exports = __webpack_public_path__ + "img/app.86793366.png";